import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button,  Flex, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { getSystemSettingsAction } from "../../../redux/services/addon-and-sponsorship/addonAndSponsorshipServices";
import { baseRouteMaker, routes } from "../../../constants/routeConsts";
import { colors } from "../../../constants/colors";
import { useTranslation } from "react-i18next";

const PayFinePaymentDetails = () => {

  const {t} = useTranslation();

  /* navigate dependencies */
  const navigate = useNavigate();
  /* navigate dependencies */

  const dispatch = useDispatch()

  const [loading, setLoading] = useState(false);

  const { systemSettings } = useSelector((state) => state.addonAndSponsorship);
  /* form dependencies */

  useEffect(()=>{
    dispatch(getSystemSettingsAction(setLoading));
  },[])

  return (
    <div style={{
      background: "linear-gradient(to bottom, #8b0000, #cd5c5c)",
        padding: 20,
        color: colors.white,
        height: "100%",
      }}>
      <Flex gap="1rem" style={{ marginBottom: "2rem" }}>
        <Button
          type="default"
          shape="circle"
          size="small"
          icon={<ArrowLeftOutlined />}
          onClick={() => {
            navigate(baseRouteMaker(routes.DASHBOARD));
          }}
        />
        <Typography.Title style={{ color: colors.white }} level={2}>
        {t("CommonUtils.payFine")}
        </Typography.Title>
      </Flex>

      <Flex
        gap="3rem"
        vertical
        style={{ maxWidth: 500, margin: "auto" }}
      >
        <Flex vertical>
          <Flex>
            <Typography.Title
              level={4}
              style={{ color: colors.white, margin: 0 }}
            ></Typography.Title>
          </Flex>
          <Flex gap="1rem" align="center">
            <Typography.Title
              level={1}
              style={{ color: colors.white, margin: 0 }}
            >
              {`${systemSettings?.organization_account_fine_percentage?.toFixed(2)} ${systemSettings?.system_currency}` || 0}
            </Typography.Title>
          </Flex>
        </Flex>

        <Flex>
          <Typography.Paragraph
            style={{ color: colors.white, margin: 0 }}
          >
            {t("CommonUtils.contributionToJustice")}
          </Typography.Paragraph>
        </Flex>

        <Flex justify="space-between">
          <Flex vertical>
            <Typography.Paragraph
              style={{ color: colors.whiteSmoke, margin: 0 }}
            >
              ReynaCare
            </Typography.Paragraph>
            <Typography.Paragraph
              style={{ color: colors.white, margin: 0 }}
            >
              {t("CommonUtils.billFor")}{" "}
              {`${systemSettings?.organization_account_fine_percentage?.toFixed(2)} ${systemSettings?.system_currency}` || 0}
            </Typography.Paragraph>
          </Flex>

          <Typography.Paragraph
            style={{ color: colors.whiteSmoke, margin: 0 }}
          >
            {`${systemSettings?.organization_account_fine_percentage?.toFixed(2)} ${systemSettings?.system_currency}` || 0}
          </Typography.Paragraph>
        </Flex>

        <Flex vertical gap="1rem">
          <Flex justify="space-between">
            <Typography.Paragraph
              style={{ color: colors.whiteSmoke, margin: 0 }}
            >
              {t("CommonUtils.subtotal")}
            </Typography.Paragraph>

            <Typography.Paragraph
              style={{ color: colors.whiteSmoke, margin: 0 }}
            >
              {`${systemSettings?.organization_account_fine_percentage?.toFixed(2)} ${systemSettings?.system_currency}` || 0}
            </Typography.Paragraph>
          </Flex>

          <hr
            style={{
              backgroundColor: colors.lightWhite,
              border: "none",
              height: "0.1px",
              width: "100%",
            }}
          />

          <Flex justify="space-between">
            <Typography.Paragraph
              style={{ color: colors.whiteSmoke, margin: 0 }}
            >
              {t("CommonUtils.totalDueToday")}
            </Typography.Paragraph>

            <Typography.Paragraph
              style={{ color: colors.whiteSmoke, margin: 0 }}
            >
              {`${systemSettings?.organization_account_fine_percentage?.toFixed(2)} ${systemSettings?.system_currency}` || 0}
            </Typography.Paragraph>
          </Flex>
        </Flex>
      </Flex>
      </div>
  )
}

export default PayFinePaymentDetails;